import React from 'react';
import { Link } from 'react-router-dom';
import { Users, FileBarChart, ClipboardList, CalendarOff, CalendarHeart } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const cards = [
  { to: '/employees', icon: Users, color: '#3b82f6', labelKey: 'dash.employees', descKey: 'dash.employeesDesc' },
  { to: '/reports', icon: FileBarChart, color: '#f59e0b', labelKey: 'dash.reports', descKey: 'dash.reportsDesc' },
  { to: '/records', icon: ClipboardList, color: '#22c55e', labelKey: 'dash.records', descKey: 'dash.recordsDesc' },
  { to: '/absences', icon: CalendarOff, color: '#ef4444', labelKey: 'dash.absences', descKey: 'dash.absencesDesc' },
];

export default function Dashboard() {
  const { t } = useLanguage();

  return (
    <div>
      <div className="page-header">
        <h1>{t('dash.title')}</h1>
      </div>

      <div className="quick-links" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 20 }}>
        {cards.map(({ to, icon: Icon, color, labelKey, descKey }) => (
          <Link key={to} to={to} className="quick-link" style={{ padding: 32, flexDirection: 'column', gap: 12 }}>
            <div style={{ width: 56, height: 56, borderRadius: 14, background: `${color}18`, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <Icon size={28} color={color} strokeWidth={1.8} />
            </div>
            <span style={{ fontSize: 18, fontWeight: 600 }}>{t(labelKey)}</span>
            <span style={{ fontSize: 12, color: 'var(--text-muted)' }}>{t(descKey)}</span>
          </Link>
        ))}
      </div>

      <div className="quick-links" style={{ display: 'grid', gridTemplateColumns: '1fr', gap: 20, marginTop: 20 }}>
        <Link to="/holidays" className="quick-link" style={{ padding: 24, flexDirection: 'column', gap: 10 }}>
          <div style={{ width: 48, height: 48, borderRadius: 12, background: '#a855f718', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <CalendarHeart size={24} color="#a855f7" strokeWidth={1.8} />
          </div>
          <span style={{ fontSize: 16, fontWeight: 600 }}>{t('dash.holidays')}</span>
          <span style={{ fontSize: 12, color: 'var(--text-muted)' }}>{t('dash.holidaysDesc')}</span>
        </Link>
      </div>
    </div>
  );
}
